var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-expert" }, [
    _c(
      "div",
      { staticClass: "viq-expert__header" },
      [
        _c(
          "svg",
          {
            attrs: {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 1l2 3 3.5 1-2.5 2.5.5 3.5L8 9.5 4.5 11l.5-3.5L2.5 5 6 4l2-3z",
                fill: "currentColor",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Expert Commentary")]),
        _vm._v(" "),
        _c(
          "el-tooltip",
          { attrs: { effect: "dark", placement: "top", "open-delay": 300 } },
          [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v("In-depth analysis from VIXIO's regulatory"),
              _c("br"),
              _vm._v("specialists related to your question."),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "viq-expert__help-icon" }, [_vm._v("?")]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-expert__list" },
      _vm._l(_vm.articles, function (article, i) {
        return _c("div", { key: i, staticClass: "viq-expert__item" }, [
          _c("div", { staticClass: "viq-expert__badges" }, [
            article.classification
              ? _c(
                  "span",
                  {
                    staticClass: "viq-expert__badge",
                    class: _vm.classificationClass(article.classification),
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(article.classification) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            article.jurisdiction
              ? _c(
                  "span",
                  {
                    staticClass:
                      "viq-expert__badge viq-expert__badge--jurisdiction",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(article.jurisdiction) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("h5", { staticClass: "viq-expert__item-title" }, [
            article.platform_url
              ? _c(
                  "a",
                  {
                    staticClass: "viq-expert__item-link",
                    attrs: {
                      href: _vm.localUrl(article.platform_url),
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v(_vm._s(article.title))]
                )
              : _c("span", [_vm._v(_vm._s(article.title))]),
          ]),
          _vm._v(" "),
          _vm.articleExcerpt(article)
            ? _c("p", { staticClass: "viq-expert__item-excerpt" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.articleExcerpt(article)) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "viq-expert__item-footer" }, [
            article.published_date
              ? _c("span", { staticClass: "viq-expert__item-date" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formatDate(article.published_date)) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            article.platform_url
              ? _c(
                  "a",
                  {
                    staticClass: "viq-expert__item-view",
                    attrs: {
                      href: _vm.localUrl(article.platform_url),
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _vm._v("\n          View full article\n          "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M5 1h6v6M11 1L5 7",
                            stroke: "currentColor",
                            "stroke-width": "1.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }